import React from 'react'
import Navbar from './component/Navbar/Navbar'
import RBanner from './component/Banner/RippleBanner'
import About from './component/About'
import Service from './component/Service'
import Portfolio from './component/Portfolio/Portfolio'
import Testimonial from './component/Testimonial/Testimonial'
import Clientslogo from './component/Clientslogo'
import Blog from './component/Blog/Blog'
import Contact from './component/Contact'
import Skill from './component/Skill/Skill'
import Footer from './component/Footer'
import lanaData from './component/lanaData'

const Home6 = () => {
  return (
    <div className="body_wrapper red_color">
      {/* <Navbar mainlogo="logo2.png" stickylogo="logo.png" /> */}
      <Navbar
        mainlogo="Logo_lana/Logo_lana_modifie.jpg"
        // mainlogo="Logo_lana/Logo_Lana.svg"
        // stickylogo="logo.png"
        stickylogo="Logo_lana/Logo_lana_modifie.jpg"
      />
      <RBanner
        lanaData={lanaData}
        bClass="banner_shap_two"
        imag="man.jpg"
        textLeft="text-left"
      />
      <About aClass="about_area" lanaData={lanaData} />
      <Service wClass="work_area" lanaData={lanaData} />
      <Portfolio />
      <Skill />
      <Testimonial />
      {/* <Clientslogo /> */}
      {/* <Blog /> */}
      <Contact lanaData={lanaData} />
      <Footer lanaData={lanaData} />
    </div>
  )
}
export default Home6
